import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Lock, Tag as TagIcon, UserPlus } from "lucide-react";
import { api } from "../lib/api";
import { Btn, Card } from "./kit";
import { CourseInfo } from "./CourseInfo";
import { useStartRealWork } from "./DemoChrome";

export const isPreviewLimit = (e) => e?.response?.status === 403 && e?.response?.data?.detail?.code === "demo_preview_limit";
export const previewCourse = (e) => e?.response?.data?.detail?.course_id;

export function PreviewPanel({ courseId, testid = "preview-panel" }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ru") ? "ru" : "en";
  const [d, setD] = useState(null);
  const startReal = useStartRealWork();
  useEffect(() => { if (courseId) api.get(`/learning/courses/${courseId}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [courseId, lang]);
  const locked = (d?.units || []).filter((u) => u.preview_locked && u.type !== "section");
  return (
    <Card className="space-y-4 border-2 border-amber-line bg-amber-soft" data-testid={testid} role="region" aria-labelledby={`${testid}-title`}>
      <div className="flex items-center gap-2"><Lock className="h-5 w-5 text-amber-ink" aria-hidden /><h2 id={`${testid}-title`} className="font-display text-xl font-semibold text-ink">{t("b8.preview_title")}</h2></div>
      <p className="text-ink" data-testid={`${testid}-text`}>{t("b8.preview_text")}</p>
      {d?.course?.info && <div><p className="font-semibold text-ink">{t("b8.preview_includes")}</p><div className="mt-2"><CourseInfo info={d.course.info} lang={lang} compact testid={`${testid}-info`} /></div></div>}
      {locked.length > 0 && <div><p className="font-semibold text-ink">{t("b8.preview_units")}</p><ul className="mt-1 ml-5 list-disc text-sm text-neutral-ink" data-testid={`${testid}-units`}>{locked.map((u) => <li key={u.key}>{u.title}</li>)}</ul></div>}
      <div className="flex flex-wrap gap-3">
        <Link to="/pricing" data-testid={`${testid}-pricing`} className="btn btn-line"><TagIcon className="h-4 w-4" aria-hidden />{t("b8.see_pricing")}</Link>
        <Btn testid={`${testid}-register`} onClick={startReal}><UserPlus className="h-4 w-4" aria-hidden />{t("b8.create_account")}</Btn>
      </div>
    </Card>
  );
}
